/**
 * Billing API client -- thin wrappers around /dm-api/billing/*.
 *
 * Used by the BillingDashboard page. All endpoints are dual-mounted on
 * the dm-backend service; the browser always hits /dm-api/* via nginx.
 */
import { dmClient } from './dmClient';

export async function fetchPublicPlans() {
  const { data } = await dmClient.get('/billing/plans');
  return data;
}

export async function fetchSubscription() {
  const { data } = await dmClient.get('/billing/subscription');
  return data;
}

export async function startSubscription(body) {
  const { data } = await dmClient.post('/billing/subscription', body);
  return data;
}

export async function cancelSubscription(body = { atPeriodEnd: true }) {
  const { data } = await dmClient.post('/billing/subscription/cancel', body);
  return data;
}

export async function updateSeats(seats) {
  const { data } = await dmClient.patch('/billing/subscription/seats', { seats });
  return data;
}

export async function fetchUsage() {
  const { data } = await dmClient.get('/billing/usage');
  return data;
}

export async function fetchInvoices(params = {}) {
  const { data } = await dmClient.get('/billing/invoices', { params });
  return data;
}

export async function fetchInvoice(invoiceId) {
  const { data } = await dmClient.get(`/billing/invoices/${invoiceId}`);
  return data;
}

export async function finalizeOverage(body = {}) {
  const { data } = await dmClient.post('/billing/invoices/finalize', body);
  return data;
}
